import ApplicationController from 'javascript/controllers/application_controller';
import { Rails } from 'javascript/utils/rails_polyfills';
import { safeLocationReplace } from 'javascript/utils/location';

function encodeBase64Utf8(value) {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary);
}

function decodeBase64Utf8(value) {
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export default class extends ApplicationController {
  static targets = [
    'form',
    'jsonDatasource',
    'htmlDatasource',
    'testEmailForm',
    'testHtmlDatasource',
    'testEmailRecipient',
  ];

  initPlugin = () => {
    const options = {
      id: '#' + this.element.id,
      authorize: {
        apiKey: this.data.get('api-key'),
        userId: this.data.get('user-id'),
      },
      templateId: this.data.get('template-id'),
      sendTestEmail: true,
      callbacks: {
        onSaveAndClose: (json, html) => {
          this.data.set('should-redirect', 'true');
          this.saveEmailContent(json, html);
        },
        onSave: (json, html) => {
          this.data.set('should-redirect', 'false');
          this.saveEmailContent(json, html);
        },
        onTestSend: (email, json, html) => {
          this.sendTestEmail({ email, html });
        },
        onInit: () => {
          setTimeout(() => {
            if (this.jsonDatasourceTarget.innerText.length > 0) {
              this.window.TopolPlugin.load(
                decodeBase64Utf8(this.jsonDatasourceTarget.innerText),
              );
            }
          });
        },
      },
    };

    this.window.TopolPlugin.init(options);
  };

  addScriptElement(callback) {
    const scriptElement = this.window.document.createElement('script');
    scriptElement.addEventListener('load', callback);
    scriptElement.src =
      'https://d5aoblv5p04cg.cloudfront.net/editor-3/loader/build.js';
    this.window.document.body.appendChild(scriptElement);
  }

  updateHeight() {
    this.element.style.height = '100%';
  }

  saveEmailContent(json, html) {
    if (
      this.htmlDatasourceTarget.tagName === 'INPUT' ||
      this.htmlDatasourceTarget.tagName === 'TEXTAREA'
    ) {
      this.htmlDatasourceTarget.value = html;
    } else {
      this.htmlDatasourceTarget.innerHTML = html;
    }

    const encodedJson = encodeBase64Utf8(JSON.stringify(json));
    if (
      this.jsonDatasourceTarget.tagName === 'INPUT' ||
      this.jsonDatasourceTarget.tagName === 'TEXTAREA'
    ) {
      this.jsonDatasourceTarget.value = encodedJson;
    } else {
      this.jsonDatasourceTarget.innerText = encodedJson;
    }
    Rails.fire(this.formTarget, 'submit');
  }

  redirect() {
    if (this.data.get('should-redirect') === 'true') {
      safeLocationReplace(this.data.get('redirect-url'));
    }
  }

  sendTestEmail({ email, html }) {
    this.testEmailRecipientTarget.value = email;
    if (
      this.testHtmlDatasourceTarget.tagName === 'INPUT' ||
      this.testHtmlDatasourceTarget.tagName === 'TEXTAREA'
    ) {
      this.testHtmlDatasourceTarget.value = html;
    } else {
      this.testHtmlDatasourceTarget.innerHTML = html;
    }
    Rails.fire(this.testEmailFormTarget, 'submit');
  }

  testEmailSuccess() {
    alert('Test Email Sent');
  }

  connect() {
    this.updateHeight();

    if (this.window.TopolPlugin) {
      this.initPlugin();
    } else {
      this.addScriptElement(this.initPlugin);
    }
  }
}
